import React, { useState, useEffect, useCallback } from "react";
import {
  Form,
  DatePicker,
  Input,
  notification,
  Button,
  Select,
  Col,
  Row,
  Upload,
  Spin,
  Radio,
  Space,
  Typography,
} from "antd";
import CurrencyInput from "react-currency-input";
import { useMediaQuery } from "react-responsive";
import config from "../../util/ApiforContext";
import {
  PlusOutlined,
  DownloadOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import { odata } from "../Filters/Helper";
import debounce from "lodash.debounce";

const { Option } = Select;
const { Text } = Typography;

const layout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 18,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const CheckPromissoryAdd = (props) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [repeatDayCount, setRepeatDayCount] = useState(1);
  const [repeatEndDayCount, setRepeatEndDayCount] = useState(1);
  const [repeatDate, setRepeatDate] = useState();
  const [spinLoading, SetSpinLoading] = useState(false);
  const [tahsilatButton, setTahsilatButton] = useState(false);
  const [odemeButton, setOdemeButton] = useState(false);
  const [checkPlan, setCheckPlan] = useState(false);

  const [bankId, setbankId] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankDropdown, setbankDropdown] = useState([]);
  const [SalesmanCode, setSalesmanCode] = useState({
    data: [],
    loading: true,
  });
  const [tenantAccountSelect, setTenantAccountSelect] = useState({
    data: [],
    loading: true,
  });

  const [teminatDropdown, setteminatDropdown] = useState([]);
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });

  const [excelType, setExcelType] = useState("");

  useEffect(() => {
    RequestHandler.get(`/Bank`).then((response) => {
      setbankDropdown(
        response.value.filter((x) => x.isSupportAccountTransaction === true)
      );
    });
  }, [setbankDropdown]);

  const onChange = (value) => {
    RequestHandler.get(`/BankBranch/GetBranchForBank?id=${value}`).then(
      (response) => {
        setbankId(value);
      }
    );
  };

  const onChangeFirm = (value) => {
    RequestHandler.get(`/Firm/GetById/${value}`).then((response) => {
      if (response.vkn !== null) {
        form.setFieldsValue({ Vkn: response.vkn });
      } else if (response.vkn === null && response.tcNo !== null) {
        form.setFieldsValue({ Vkn: response.tcNo });
      } else {
        form.setFieldsValue({ Vkn: "" });
      }
    });
  };

  const onChangeFirmHandler = useCallback(debounce(onChangeFirm, 300), []);

  const [currencyDropdown, setcurrencyDropdown] = useState([]);
  const [ManualTransactionTypeDropdown, setManualTransactionTypeDropdown] =
    useState([]);
  const errorList = [];
  const errorListNotification = (type) => {
    errorList.map((item) => {
      notification[type]({
        message: "Hata",
        description: item,
        duration: 5,
      });
    });
  };

  const changeButton = (val) => {
    if (val === "1") {
      setTahsilatButton(true);
      setOdemeButton(false);
    } else if (val === "2") {
      setOdemeButton(true);
      setTahsilatButton(false);
    }
  };

  const onChangeCheck = (val) => {
    setCheckPlan(val);


    if(val) {
      setExcelType("1");
    }
    else {
      setExcelType("0");
    }
  };

  const onSuccess = () => {
    form.resetFields();
    setFileList([]);
    if (props.onSuccess) props.onSuccess();
  };

  const onChangeSalesmanCode = (e) => {
    setSalesmanCode(e);
  };
  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };
  const onFirmSearchHandler = useCallback(debounce(onFirmSearch, 300), []);
  useEffect(() => {
    RequestHandler.get(`/Types/GetManualTransactionTypes`).then((response) => {
      setteminatDropdown(response);
    });

    RequestHandler.get(`/Currency`).then((response) => {
      setcurrencyDropdown(response.value);
    });
    RequestHandler.get(`/MonthlyPlanType`).then((response) => {
      setManualTransactionTypeDropdown(response.value);
    });
    RequestHandler.get(`/ErpLogo/GetSalesmanCodes`, [], false, {
      rawResponse: true,
    }).then((response) => {
      if (response != "") {
        setSalesmanCode({
          data: response,
          loading: false,
        });
      } else {
        setSalesmanCode({
          data: [],
          loading: false,
        });
      }
    });
  }, []);

  const { TextArea } = Input;

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Ekleme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const excelDownload = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Excel yükleme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const downloadAddExcel = () => {
    window.open(
      `${config.apiUrl
      }/CheckPromissory/DownloadAddExcel?type=${excelType}&t=${RequestHandler.getToken()}`
    );
  };

  const onFinish = (values) => {
    const valuedate = values["TransactionDate"];

    const repeatTime = values.repeat?.value;
    const repeatKind = values.repeat?.day;
    const repeatContinue = values.repeatContinue == 1 ? null : repeatDayCount;
    const repeatEndDateDay =
      values.repeatEndDate == 2 ? repeatEndDayCount : null;
    const repeatEndDate = values.repeatEndDate == 3 ? repeatDate : null;

    RequestHandler.post(
      `/MonthlyPlan`,
      {
        MonthlyPlanTypeId: values.MonthlyPlanTypeId,
        OtherTransactionProcessType: values.OtherTransactionProcessType, //Tahsilat anlamına gelir.
        Description: values.Description,
        Amount: 1,
        AmountString: values.Amount,
        TransactionDate: valuedate.format("YYYY-MM-DD"),
        CurrencyId: values.CurrencyCode,
        FirmId: values.FirmId,
        BankId: bankId,
        BankName: values.bankName,
        BankBranchCode: values.BankBranchCode,
        IsRepeat: false,
        RepeatTime: repeatTime,
        RepeatKind: repeatKind,
        RepeatContinue: repeatContinue,
        repeatEndDateDay: repeatEndDateDay,
        repeatEndDate: repeatEndDate?.format("YYYY-MM-DD"),
        MainType: 1,
        PaymentPlace: values.PaymentPlace,
        SerialNo: values.SerialNo,
        Vkn: values.Vkn,
        SalesmanCode: values.salesmanCode,
      },
      false,
      { rawResponse: true }
    ).then((res) => {
      if (res.status == 200) {
        openNotificationWithIcon("success");
      } else {
        SetSpinLoading(false);
      }
      setLoading(false);
      onSuccess();
    });
  };

  const propsTahsilat = {
    name: "excel",
    action: `${config.apiUrl}/MonthlyPlan/ImportExcel?type=1&monthlyPlanTypeNumber=${excelType}`,
    headers: { Authorization: "bearer " + RequestHandler.getToken() },
    onChange(info) {
      const { response, status } = info.file;

      if (info.fileList.length > 0) {
        SetSpinLoading(true);
      }
      if (info.file.status === "done") {
        excelDownload("success");
        setTimeout(
          function () {
            window.location.reload();
          }.bind(this),
          2000
        );
      } else if (info.file.status === "error") {
        if (info.file.response.statusCode === 406) {
          info.file.response.data.map((item) => {
            errorList.push(item);
          });
          errorListNotification("error");
          setTimeout(function () {
            window.location.reload();
          }, 5000);
        } else {
          const notificationType = response.success ? "success" : "error";

          notification[notificationType]({
            message: response.message,
            duration: 3,
          });
          if (!response.success) {
            downloadImportResult(info.file.response.data);
          }
          setTimeout(function () {
            window.location.reload();
          }, 5000);
        }
      }
    },
  };
  const downloadImportResult = (fileName) => {
    window.open(
      `${config.apiUrl
      }/CheckPromissory/DownloadImportResult?t=${RequestHandler.getToken()}&fileName=${fileName}&type=${excelType}`
    );
  };
  const propsOdeme = {
    name: "excel",
    action: `${config.apiUrl}/MonthlyPlan/ImportExcel?type=2`,
    headers: { Authorization: "bearer " + RequestHandler.getToken() },
    onChange(info) {
      const { response, status } = info.file;

      SetSpinLoading(true);
      if (info.file.status === "done") {
        excelDownload("success");
        setTimeout(
          function () {
            window.location.reload();
          }.bind(this),
          2000
        );
      } else if (info.file.status === "error") {
        if (info.file.response.statusCode === 406) {
          info.file.response.data.map((item) => {
            errorList.push(item);
          });
          errorListNotification("error");
          setTimeout(function () {
            window.location.reload();
          }, 5000);
        } else {
          const notificationType = response.success ? "success" : "error";

          notification[notificationType]({
            message: response.message,
            duration: 3,
          });
          if (!response.success) {
            downloadImportResult(info.file.response.data);
          }
          setTimeout(function () {
            window.location.reload();
          }, 5000);
        }
      }
    },
  };
  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };
  return (
    <div>
      <Spin tip="Excel yükleniyor..." spinning={spinLoading}>
        <Form
          {...layout}
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
        >
          <Row>
            <Col span={24}>
              <Form.Item
                label="Ödeme/Tahsilat Tipi "
                style={{ marginTop: "4%" }}
                name="OtherTransactionProcessType"
                rules={[
                  {
                    required: true,
                    message: 'Lütfen Ödeme/Tahsilat tipi alanını boş bırakmayın.',
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Ödeme/Tahsilat tipi seçiniz"
                  optionFilterProp="children"
                  onChange={changeButton}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {teminatDropdown.map(item => (
                    <Option key={item.key}>{item.value}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="İşlem Tipi"
                name="MonthlyPlanTypeId"
                rules={[
                  {
                    required: true,
                    message: "Lütfen İşlem Tipi alanını boş bırakmayın.",
                  },
                ]}
              >
                <Select
                  onChange={(value, selectedObject) => {
                    var changeCheckValue =
                      selectedObject.children.toLowerCase().trim() === "çek"
                        ? false
                        : true;
                    onChangeCheck(changeCheckValue);
                  }}
                  showSearch
                  placeholder="İşlem tipi seçiniz"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {ManualTransactionTypeDropdown.filter(
                    (x) =>
                      x.name.toLowerCase().trim() === "çek" ||
                      x.name.toLowerCase().trim() === "senet"
                  ).map((item) => (
                    <Option key={item.id}>{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Cari Adı/Ünvanı"
                name="FirmId"
                rules={[
                  {
                    required: true,
                    message:
                      "Lütfen Cari Adı/Ünvanı tipi alanını boş bırakmayın.",
                  },
                ]}
              >
                <Select
                  allowClear
                  showSearch
                  placeholder="En az 2 harf giriniz.."
                  onSearch={onFirmSearchHandler}
                  onChange={onChangeFirmHandler}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                    option.code
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                  loading={firmSelect.loading}
                // onChange={(value, option) => onChangeFirm(value)}
                >
                  {firmSelect.data.map((item) => (
                    <Select.Option
                      key={item.id}
                      value={item.id}
                      code={item.firmBranchNumber}
                    >
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item label="Tckn/Vkn" name="Vkn">
                <Input disabled="true" />
              </Form.Item>
              <Form.Item
                label="Tarih"
                name="TransactionDate"
                rules={[
                  {
                    required: true,
                    message: "Lütfen Tarih alanını boş bırakmayın.",
                  },
                ]}
              >
                <DatePicker
                  format={"DD-MM-YYYY"}
                  placeholder="Tarih seçiniz"
                  style={{ width: "100%" }}
                />
              </Form.Item>
              <Form.Item
                label="Tutar"
                name="Amount"
                rules={[
                  {
                    required: true,
                    message: "Lütfen Tutar alanını boş bırakmayın.",
                  },
                ]}
              >
                <CurrencyInput
                  className="ant-input"
                  style={{ width: "100%" }}
                  decimalSeparator=","
                  thousandSeparator="."
                />
              </Form.Item>
              <Form.Item
                label="Para Birimi"
                name="CurrencyCode"
                initialValue="1"
                rules={[
                  {
                    required: true,
                    message: "Lütfen Para Birimi alanını boş bırakmayın.",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Para birimini seçiniz"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {currencyDropdown.map((item) => (
                    <Option key={item.id}>
                      {item.code + " (" + item.symbol + ")"}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              {!checkPlan ? (
                <>
                  <Form.Item label="Ödeme Yeri" name="PaymentPlace">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Seri No" name="SerialNo">
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Banka Adı"
                    name="BankId"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen banka alanını boş bırakmayın.",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Seçiniz."
                      optionFilterProp="children"
                      onChange={onChange}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {bankDropdown.map((item) =>
                        item.name === "Çek" ? (
                          ""
                        ) : (
                          <Option key={item.id}>{item.name}</Option>
                        )
                      )}
                    </Select>
                    {/* <Input /> */}
                  </Form.Item>
                  <Form.Item label="Banka-Şube Kodu" name="BankBranchCode">
                    <Input />
                  </Form.Item>
                </>
              ) : (
                <>

                  <Form.Item
                    label="Banka Adı"
                    name="BankId"
                  >
                    <Select
                      showSearch
                      placeholder="Seçiniz."
                      optionFilterProp="children"
                      onChange={onChange}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {bankDropdown.map((item) =>
                        item.name === "Çek" ? (
                          ""
                        ) : (
                          <Option key={item.id}>{item.name}</Option>
                        )
                      )}
                    </Select>
                    {/* <Input /> */}
                  </Form.Item>


                </>
              )}
              <Form.Item label="Satış Elemanı" name="salesmanCode">
                <Select
                  allowClear
                  showSearch
                  placeholder="Satış Elemanı seçiniz"
                  optionFilterProp="children"
                  // onChange={onChangeSalesmanCode}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {SalesmanCode.data.length > 0 &&
                    SalesmanCode.data.map((item) => (
                      <Option key={item.KOD} value={item.ACIKLAMASI}>
                        {item.ACIKLAMASI + " " + item.KOD}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            {
              excelType ? <>
                <Col span={6} style={{ marginLeft: -5 }} >

                  <Upload {...propsTahsilat}>
                    <Button icon={<UploadOutlined />}>Excel ile {excelType === "0" ? "Çek" : "Senet"} Ekle</Button>
                  </Upload>
                </Col>

                <Col span={6} style={{ marginLeft: 5 }} >
                  <Button icon={<DownloadOutlined />} onClick={downloadAddExcel}
                          loading={loading}>
                    Excel Şablonu İndir
                  </Button>
                </Col>
              </> : <></>
            }


            <Col span={18}></Col>
            <Col span={3}>
              <Form.Item {...tailLayout}>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  htmlType="submit"
                  onClick={() => setLoading(true)}
                  loading={loading}
                >
                  Ekle
                </Button>
              </Form.Item>
            </Col>
            <Col span={6}></Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
};
export default CheckPromissoryAdd;
